module.exports = __webpack_public_path__ + "static/media/PlicaturaBN_sq2.160bbdcf.jpg";